"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateWebPushVariantCommand = void 0;
const AbstractUpdateVariantCommand_1 = require("./AbstractUpdateVariantCommand");
class UpdateWebPushVariantCommand extends AbstractUpdateVariantCommand_1.AbstractUpdateVariantCommand {
    constructor(api, appId, variantId) {
        super(api, appId, variantId, 'web_push');
        this.withPublicKey = (publicKey) => {
            this.def.publicKey = publicKey;
            return this;
        };
        this.withPrivateKey = (privateKey) => {
            this.def.privateKey = privateKey;
            return this;
        };
        this.withAlias = (alias) => {
            this.def.alias = alias;
            return this;
        };
    }
}
exports.UpdateWebPushVariantCommand = UpdateWebPushVariantCommand;
//# sourceMappingURL=UpdateWebPushVariantCommand.js.map